(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');

    // click-directive to edit a user 
    module.directive('userEdit', ['$state', '$uibModalStack',
        function ($state, $uibModalStack) {
            var directive = {
                link: link,
                restrict: 'A',
                scope: {
                    id: '@' // user id
                }
            };
            return directive;

            function link(scope, element) {

                // click listener
                element.on('click', function () {
                    edit();
                });

                // edit
                function edit() {
                    // close all possibly open modals
                    $uibModalStack.dismissAll();

                    $state.go('Home.UserDetail.Profile', { 'userId': scope.id });
                }


                // on destroy
                scope.$on("$destroy", function () {
                    element.off("click");
                });

            }
        }]);

})();